let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("h8oos")).then(() => parcelRequire('kvgVs'));